import { api } from '@store/api'
import { TNotificationsResponse } from '@store/notifications/type'

export const parentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<TNotificationsResponse, { page?: number; page_size?: number }>({
      query: ({ page = 1, page_size = 10 }) => ({
        url: '/notifications/',
        params: { page, page_size },
      }),
      // // Only have one cache entry because the arg always maps to one string
      // serializeQueryArgs: ({ endpointName }) => endpointName,
      // // Always merge incoming data to the cache entry
      // merge: (currentCache, newItems) => {
      //   console.log('currentCache', currentCache)
      //   currentCache.results.push(...newItems.results)
      // },
      // // Refetch when the page arg changes
      // forceRefetch({ currentArg, previousArg }) {
      //   return currentArg !== previousArg
      // },
    }),
    getHasUnread: builder.query<boolean, any>({
      query: () => ({
        url: '/notifications/has_unread/',
      }),
      providesTags: ['hasUnread'],
    }),
    setRead: builder.mutation<any, any>({
      query: () => ({
        url: '/notifications/read_all/',
        method: 'PATCH',
      }),
      invalidatesTags: ['hasUnread'],
    }),
  }),
})

export const { useGetNotificationsQuery, useLazyGetNotificationsQuery, useGetHasUnreadQuery, useSetReadMutation } = parentApi
